import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const createCursus = (
  payload: any,
  language: string,
  setLoading: Function,
  showAlert: Function,
  popAlert: Function,
  setShowCreationModal: Function,
  resetSelection: Function,
  onSuccess?: Function
) => {
  setLoading(true);

  ApiService.post("cursus", payload)
    .then((response) => {
      setShowCreationModal(false);
      resetSelection();
      onSuccess?.();
      showAlert({
        type: "success",
        title: translate(language, "PAGES.COURSES.MODAL.DST_ALERT.SUCCESS.TITLE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.COURSES.MODAL.DST_ALERT.SUCCESS.OPEN_CURSUS"),
            variant: "secondary",
            onClick: () => {
              popAlert();
              window.open(`/course/${response.data.cursus_id}`, "_blank");
            },
          },
          {
            label: translate(language, "PAGES.COURSES.MODAL.DST_ALERT.SUCCESS.CREATE_CURSUS"),
            variant: "primary",
            onClick: () => {
              popAlert();
              setShowCreationModal(true);
            },
          },
        ],
      });
    })
    .catch((error) => {
      console.error("Error creating cursus:", error);
      setShowCreationModal(false);
      showAlert({
        type: "danger",
        title: translate(language, "PAGES.COURSES.MODAL.DST_ALERT.ERROR.TITLE"),
        message: error.response?.data?.error?.message,
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.COURSES.MODAL.DST_ALERT.ERROR.TRY_AGAIN"),
            variant: "primary",
            onClick: () => {
              popAlert();
              setShowCreationModal(true);
            },
          },
        ],
      });
    })
    .finally(() => setLoading(false));
};
